import { useTranslation } from 'react-i18next';
import { Button, ModalComponentWrapper } from '@/shared/components';
import type { DepositModalBaseProps } from '@/shared/types';
import { cn } from '@/shared/utils';
import {
  DepositSccrsForm,
  useDepositSccrsFormLogic,
} from '@/features/deposit-sccrs';

function DepositSccrsModalFooter({
  onSubmit,
  isLoading,
}: {
  onSubmit: () => void;
  isLoading: boolean;
}) {
  const { t } = useTranslation();

  return (
    <Button
      type="submit"
      variant={'default'}
      size="lg"
      disabled={isLoading}
      loading={isLoading}
      onClick={onSubmit}
      className={cn('w-full gap-[0.8rem] [&_svg]:h-[2.4rem]')}>
      {t('depositMethods.continueButton')}
    </Button>
  );
}

export function DepositSccrsModal({ onBack, title }: DepositModalBaseProps) {
  const {
    form,
    handleFormSubmit,
    currencyOptions,
    platformOptions,
    firstError,
    amountPlaceholder,
    commissionData,
    shouldShowCommission,
    isSubmitInProgressWithoutErrors,
    formError,
    isLoading,
    showResultModal,
    isSuccess,
  } = useDepositSccrsFormLogic({
    initialData: {
      currencyCode: 'BYN',
    },
  });

  const submitForm = () => {
    form.handleSubmit(handleFormSubmit)();
  };

  return (
    <ModalComponentWrapper
      title={title}
      onBack={onBack}
      footer={
        !showResultModal && (
          <DepositSccrsModalFooter
            onSubmit={submitForm}
            isLoading={isSubmitInProgressWithoutErrors}
          />
        )
      }>
      <DepositSccrsForm
        form={form}
        onBack={onBack}
        handleFormSubmit={handleFormSubmit}
        currencyOptions={currencyOptions}
        platformOptions={platformOptions}
        amountPlaceholder={amountPlaceholder}
        commissionData={commissionData}
        shouldShowCommission={shouldShowCommission}
        isSubmitInProgressWithoutErrors={isSubmitInProgressWithoutErrors}
        formError={!isSubmitInProgressWithoutErrors && !!formError}
        firstError={firstError?.message}
        isLoading={isLoading}
        showResultModal={showResultModal}
        isSuccess={isSuccess}
      />
    </ModalComponentWrapper>
  );
}
